import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  
  // {
  //   path: 'product',
  //   loadChildren: () =>
  //     import('./product/product.module').then((m) => m.ProductModule),
  // },

  { path: 'products', loadChildren: () => import('./products/products.module').then(m => m.ProductsModule) },
  
  {
    path: 'support',
    loadChildren: () =>
      import('./support/support.module').then((m) => m.SupportModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./service/service.module').then((m) => m.ServiceModule),
  },
  {
    path: 'saas',
    loadChildren: () =>
      import('./saas/saas.module').then((m)=> m.SaasModule),
  },
  {
    path: 'franchise',
    loadChildren: () =>
      import('./franchise/franchise.module').then((m)=> m.FranchiseModule),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./blog/blog.module').then((m)=> m.BlogModule),
  },
  { path: 'media', loadChildren: () => import('./media/media.module').then(m => m.MediaModule) },
 
  { path: '**', redirectTo: '/home' } ,
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
